import { useMemo } from 'react';
import { useDomains } from './useDomains';

/**
 * Hook for creating a domain lookup map for efficient domain name resolution
 * Returns a map from domainId to domain info (name and code)
 */
export const useTenantDomainsLookup = (tenantId: string) => {
  const { data, isLoading, isError, error } = useDomains(tenantId);

  const domainLookup = useMemo(() => {
    if (!data) return new Map();

    const lookup = new Map<string, { name: string; code?: string }>();

    // Flatten infinite query pages and map domains
    data.pages.forEach((page) => {
      page.items.forEach((domain) => {
        lookup.set(domain.domainId, {
          name: domain.name,
          code: domain.code,
        });
      });
    });

    return lookup;
  }, [data]);

  return {
    domainLookup,
    isLoading,
    isError,
    error,
  };
};
